var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useDispatch } from 'react-redux';
import styles from './AuthPage.module.scss';
import { removeErrorNotification } from '../Redux/_actions';
import ResetForm from './Forms/ResetForm';
import { history } from '../_history';
import MainForm from './Forms/MainForm';
import WelcomeForm from './Forms/WelcomeForm';
var AuthPage = function (_a) {
    var isConfirmReset = _a.isConfirmReset, isUserConfirmed = _a.isUserConfirmed;
    var _b = useState(true), isLoginPage = _b[0], setIsLoginPage = _b[1];
    var _c = useState(false), isResetPassPage = _c[0], setIsResetPassPage = _c[1];
    var _d = useState(false), isSignUpFinishPage = _d[0], setIsSignUpFinishPage = _d[1];
    var dispatch = useDispatch();
    var user = localStorage.getItem('user');
    useEffect(function () {
        isConfirmReset && setIsResetPassPage(true);
        isUserConfirmed && setIsSignUpFinishPage(true);
    }, []);
    useEffect(function () {
        if (user) {
            history.push('/dashboard');
        }
    }, [user]);
    useEffect(function () {
        dispatch(removeErrorNotification(null));
    }, [isLoginPage, isResetPassPage]);
    return (_jsx(Row, __assign({ className: styles.layout }, { children: _jsx(Col, { children: _jsx(Content, __assign({ className: styles.registrationCard }, { children: isResetPassPage ? (_jsx(ResetForm, { closeResetForm: setIsResetPassPage, isConfirmReset: isConfirmReset })) : isSignUpFinishPage ? (_jsx(WelcomeForm, { setIsLoginPage: setIsLoginPage, isUserConfirmed: isUserConfirmed, setIsSignUpFinishPage: setIsSignUpFinishPage })) : (_jsx(MainForm, { isLoginPage: isLoginPage, setIsLoginPage: setIsLoginPage, setIsResetPassPage: setIsResetPassPage, setIsSignUpFinishPage: setIsSignUpFinishPage })) })) }) })));
};
export default AuthPage;
